<mat-card [attr.id]="type===''?'':'type-is-word-or-lettersSelecting'"
  [ngClass]="{'two-columns-layout': isTwoColumns, 'listen-content': type === 'listen' }"
  class="activities-card inner-scroll mat-elevation-z0 qcuContainer">

  <mat-card-header>
    <mat-card-title [class.sub-instruction-enabled]="showSubInstruction">
      @if (isConsigneContainMedia(wording) || (!isDataEmpty(wording) && !isDataEmpty(wordingAudio)) || (!isDataEmpty(wording) && isDataEmpty(wordingAudio))) {
        <app-consignes
          (isReading)="ttsReadingEvent($event)"
          [additionalHiddenText]="showSubInstruction?('activities.sub_instruction_qmcu' | translate):''"
          [autoRead]="isAutoReadActive('wording')" [readable]="!isConsigneContainMedia(wording)"
          [language]="language"
          [ngClass]="{'consigneImg': isWordingImg()}"
          [wordingAudio]="wordingAudio"
          [wording]="wording"
        ></app-consignes>
      }
      @if (showSubInstruction) {
        <h2
        [ngClass]="isTTSReading?.value ? 'read-in-progress':'read-not-in-progress'">{{ 'activities.sub_instruction_qmcu' | translate }}</h2>
      }
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    @if ((isConsigneContainMedia(instruction) || (!isDataEmpty(instruction) && !isDataEmpty(instructionAudio))  || (!isDataEmpty(instruction) && isDataEmpty(instructionAudio))) && type !== 'listen') {
      <app-consignes
        [autoRead]="isAutoReadActive('instruction')" [readable]="!isConsigneContainMedia(instruction)"
        [language]="language"
        [instructionAudio]="instructionAudio"
        [instruction]="instruction"
        [ngClass]="{'consigneImg': isInstructionImg()}"
        questionTypeName="{{ 'activities.questionTypeName.app-qcu' | translate }}"
        >
      </app-consignes>
    }

    @for (f of referenceActivityGranule?.flashcards; track f) {
      <app-flashcard [class.button-image]="f.image"
        [class.is-audio]="f.audio?.uri"
        [flashCard]="f">
      </app-flashcard>
    }

    @if (displaySaveBtn && !answerContainImg && !areAnswersContainFlashcard() && !areAnswersContainAudio()) {
      <div
        [attr.id]="type===''?'container-for-answers-available':'container-for-answers-available-text-version'"
        [ngClass]="columnClass" class="available-answers"
        >
        @for (option of availableAnswers; track option) {
          <div>
            <button
              (click)="validate(option)"
              [class]="getStateAnswer(option)"
              [disabled]="isDisabledOptions"
              class="btn-option">
              <span
                [appDayRelativeNameToString]="{language_key: language}"
                [appTimeSlotToString]="{language_key: language}"
                [innerHTML]="option.answer | stringToHtml"
              ></span>
            </button>
          </div>
        }
      </div>
    }
    @if (!displaySaveBtn && !answerContainImg && !areAnswersContainFlashcard() && !areAnswersContainAudio()) {
      <mat-radio-group
        [(ngModel)]="valueChecked"
        [ngClass]="{showFinalAnswers: testAnswer || displaySolution || answerSaved, answersChecked: testAnswer}">
        @for (option of availableAnswers | intToBoolean: 'correct_answer':'select'; track option) {
          <mat-radio-button (change)="validate(option)"
            [disableRipple]="true"
            [disabled]="isDisabledOptions"
            [ngClass]="optionState(option)" [value]="option.answer"
            appAddClassInRegardOfTextHeight>
            <span
              [appDayRelativeNameToString]="{language_key: language}"
              [appTimeSlotToString]="{language_key: language}"
              [innerHTML]="option.answer | stringToHtml | translate"
            ></span>
          </mat-radio-button>
        }
      </mat-radio-group>
    }

    @if (answerContainImg && !areAnswersContainFlashcard()) {
      <div [attr.id]="type===''?'container-for-answers-available':'container-for-answers-available-text-version'"
        [ngClass]="columnClass" class="available-answers">
        @for (option of availableAnswers ; let index = $index; track option) {
          <div (click)="validate(option)"
            (keydown.enter)="validate(option)"
            [attr.aria-selected]="optionState(option) === 'selected'"
            role="button"
            tabindex="0"
            [ngClass]="optionState(option)" class="button-image">
            <img [attr.id]="'imgToZoom' + uuid + index.toString()" [src]="option.image" [attr.alt]="option?.alt"/>
            @if (isImageFullscreenButtonEnabled()) {
              <div class="action-buttons">
                <app-zoomable [uuid]="uuid" [index]="index"></app-zoomable>
              </div>
            }
          </div>
        }
      </div>
    }


    @if (!answerContainImg && areAnswersContainFlashcard()) {
      <div [attr.id]="type===''?'container-for-answers-available':'container-for-answers-available-text-version'"
        [ngClass]="columnClass" class="available-answers">
        @for (option of availableAnswers; let index = $index; track option) {
          @if (option.flashcards) {
            @for (flashcard of option.flashcards; track flashcard) {
              <app-flashcard
                [class.button-image]="flashcard.image"
                [class.is-audio]="flashcard.audio?.uri"
                [ngClass]="optionState(option)"
                [flashCard]="flashcard"
                (click)="validate(option)">
              </app-flashcard>
            }
          }
        }
      </div>
    }

    @if (areAnswersContainAudio()) {
      <div [attr.id]="type===''?'container-for-answers-available':'container-for-answers-available-text-version'"
        [ngClass]="columnClass" class="available-answers">
        @for (option of availableAnswers; let index = $index; track option) {
          <button
            class="qcu__audio-button"
            [ngClass]="optionState(option)"
            (click)="playAudioAndValidate(option.audio.id, option)">
            <mat-icon [svgIcon]="'qcm-qcu__audio-' + (index + 1)"></mat-icon>
            @if (option.audio) {
              <audio
                [src]="option.audio.uri"
                [id]="option.audio.id">
              </audio>
            }
          </button>
        }
      </div>
    }

  </mat-card-content>

  @if (displayFeedback) {
    <div class="answer-state-msg wrongreply">
      <p>{{ 'activities.feedback.try_correct' | translate }}</p>
    </div>
  }

  <mat-card-footer>

    @if (isPercentileDisplayAllowed) {
      <div
        class="gradePercentil">{{ 'generic.score' | translate }}{{ showPercentile }}
      </div>
    }

    @if (!isActivityEmbeddedDone) {
      @for (button of buttons; track button) {
        @if (button.display) {
          <button (click)="onAction(button)"
            [disabled]="button.disable">
            <span>{{ button.title | translate }}</span>
            @if (button.svgIcon) {
              <mat-icon
                [svgIcon]="button.svgIcon">
              </mat-icon>
            }
          </button>
        }
      }
    }

  </mat-card-footer>

</mat-card>

@if (!!feedbackFromApi && isActivityEmbeddedDone) {
  <app-activities-feedback
    (action)="actionFromFeedback($event)"
    [activityType]="activityType"
    [feedback]="feedbackFromApi"
    [buttons]="feedbackButtons"
    [answerStatus]="answerStatus">
  </app-activities-feedback>
}